(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gr-catalog-contact"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gr-catalog-contact')) {
    customElements.define('gr-catalog-contact', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.details = this.querySelector('details');
        this.dismiss = event => {
          if (!this.details.open) return;
          if (event.type === 'keydown') {
            if (event.key !== 'Escape') return;
            this.details.open = false;
            this.querySelector('summary').focus({preventScroll: true});
          } else if (!this.contains(event.target) || event.target.closest('[data-gr-sales]')) {
            this.details.open = false;
          }
        };
        document.addEventListener('click', this.dismiss);
        this.addEventListener('keydown', this.dismiss);
        if (typeof subscribe !== 'function') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (data.sectionId !== this.dataset.section || !data.variant) return;
          const source = data.html.querySelector('gr-catalog-contact');
          if (!source) return;
          const newLinks = new Map([...source.querySelectorAll('[data-gr-sales]')].map(link => [link.dataset.grSales, link.href]));
          this.querySelectorAll('[data-gr-sales]').forEach(link => {
            const href = newLinks.get(link.dataset.grSales);
            if (href) link.href = href;
          });
          const stock = this.querySelector('.gr-catalog-contact__stock');
          stock?.toggleAttribute('data-empty', Boolean(source?.querySelector('[data-empty]')));
        });
      }
      disconnectedCallback() {
        this.unsubscribe?.(); this.unsubscribe = null;
        document.removeEventListener('click', this.dismiss);
        this.removeEventListener('keydown', this.dismiss);
        this.initialized = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gr-location-availability"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gr-location-availability')) {
    customElements.define('gr-location-availability', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.text = this.querySelector('[role="status"]');
        this.variant = this.dataset.variant;
        this.onVisibility = () => { if (!document.hidden) this.refresh(); };
        document.addEventListener('visibilitychange', this.onVisibility);
        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
            if (String(data.sectionId) !== this.dataset.section) return;
            this.variant = data.variant?.id ? String(data.variant.id) : '';
            this.refresh(true);
          });
        }
        this.timer = setInterval(() => { if (!document.hidden) this.refresh(); }, 30000);
        this.refresh(true);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.unsubscribe?.();
        clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.initialized = false;
      }
      show(state, text) {
        this.dataset.state = state;
        if (this.text.textContent !== text) this.text.textContent = text;
      }
      async refresh(selectionChanged = false) {
        if (!selectionChanged && this.controller && !this.controller.signal.aborted && this.pending) return;
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        const variant = this.variant;
        if (this.hasAttribute('data-is-upcoming')) { this.show('upcoming', this.dataset.upcoming); return; }
        if (!/^\d+$/.test(variant || '') || !this.dataset.endpoint) { this.show('unknown', this.dataset.unknown); return; }
        if (selectionChanged) this.show('loading', this.dataset.loading);
        this.pending = true;
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const url = new URL(this.dataset.endpoint);
          if (url.protocol !== 'https:') throw new Error('endpoint');
          url.searchParams.set('variant', variant);
          const response = await fetch(url, { credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer', signal: controller.signal });
          if (!response.ok) throw new Error('availability');
          const data = await response.json();
          if (this.controller !== controller || !this.isConnected || this.variant !== variant) return;
          if (data.variant_id !== variant || !Array.isArray(data.locations)) throw new Error('variant');
          const checked = Date.parse(data.checked_at);
          if (!Number.isFinite(checked) || Date.now() - checked > 60000 || checked - Date.now() > 10000) throw new Error('stale');
          const locations = [...new Set(data.locations)];
          if (locations.some(key => !['matriz', 'sucursal'].includes(key))) throw new Error('location');
          if (data.status === 'in_stock' && locations.length) {
            this.show('in_stock', locations.length === 2 ? this.dataset.both : locations[0] === 'matriz' ? this.dataset.main : this.dataset.branch);
          } else if (data.status === 'out_of_stock' && !locations.length) {
            this.show('out_of_stock', this.dataset.soldOut);
          } else if (data.status === 'upcoming') {
            this.show('upcoming', this.dataset.upcoming);
          } else {
            this.show('unknown', this.dataset.unknown);
          }
        } catch {
          if (this.controller === controller && this.isConnected) this.show('unknown', this.dataset.unknown);
        } finally {
          clearTimeout(timeout);
          if (this.controller === controller) this.pending = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gr-product-options')) {
    class GrProductOptions extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const source = this.querySelector('[data-gr-product-options]');
        const host = this.closest('.product__info-container');
        if (!source || !host) return;
        try { this.data = JSON.parse(source.textContent); } catch (_) { return; }
        const requested = new URLSearchParams(location.search).get('variant');
        this.selected = this.data.variants.find(variant => String(variant.id) === requested)
          || this.data.variants.find(variant => variant.id === this.data.selected);
        if (!this.selected) return;
        this.initialized = true;
        this.host = host;
        this.productInfo = this.closest('product-info');
        this.cache = new Map();
        this.onClick = event => {
          const control = event.target.closest('a[data-gr-variant]');
          if (!control || !this.contains(control) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (typeof this.productInfo?.handleUpdateProductInfo !== 'function') return;
          event.preventDefault();
          const variant = this.data.variants.find(item => String(item.id) === control.getAttribute('data-gr-variant'));
          if (variant) this.selectVariant(variant, control.getAttribute('data-gr-option-index'));
        };
        this.addEventListener('click', this.onClick);
        this.renderOptions();
        this.syncVisibility();
        this.observer = new MutationObserver(() => this.syncVisibility());
        this.observer.observe(host, { childList: true, subtree: true });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.removeEventListener('click', this.onClick);
        this.resizeObserver?.disconnect();
        this.observer?.disconnect();
        this.host?.classList.remove('gr-product-options-active');
        this.initialized = false;
      }
      syncVisibility() {
        this.hidden = false;
        this.host.classList.add('gr-product-options-active');
        this.stabilizeMedia();
        const sku = this.host.querySelector('[id^="Sku-"]');
        if (sku && this.selected.sku) {
          if (sku.textContent !== this.selected.sku) sku.textContent = this.selected.sku;
          sku.classList.remove('hidden', 'visibility-hidden');
        }
      }
      stabilizeMedia() {
        const stage = this.productInfo?.querySelector('.rio-media-gallery .pwzrswiper-container');
        if (!stage || this.stage === stage) return;
        this.stage = stage;
        this.productInfo.classList.add('gr-product-media-stable');
        const resize = () => {
          const width = Math.round(stage.getBoundingClientRect().width);
          if (width > 0) this.productInfo.style.setProperty('--gr-product-stage', `${width}px`);
        };
        resize();
        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver?.disconnect();
          this.resizeObserver = new ResizeObserver(resize);
          this.resizeObserver.observe(stage);
        }
      }
      async selectVariant(variant, optionIndex) {
        if (variant.id === this.selected.id) {
          this.controller?.abort();
          this.removeAttribute('aria-busy');
          return;
        }
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        const url = new URL(this.data.url, location.origin);
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        url.searchParams.set('variant', variant.id);
        const request = new URL(url);
        request.searchParams.set('section_id', this.productInfo.sectionId);
        this.setAttribute('aria-busy', 'true');
        try {
          let text = this.cache.get(variant.id);
          if (!text) {
            const response = await fetch(request, {signal: controller.signal, credentials: 'same-origin'});
            if (!response.ok) throw new Error('variant');
            text = await response.text();
            if (controller.signal.aborted) return;
            if (this.cache.size >= 20) this.cache.delete(this.cache.keys().next().value);
            this.cache.set(variant.id, text);
          }
          if (controller.signal.aborted || !this.isConnected) return;
          const html = new DOMParser().parseFromString(text, 'text/html');
          const native = JSON.parse(html.querySelector('variant-selects [data-selected-variant]')?.textContent || 'null');
          if (!native || String(native.id) !== String(variant.id)) throw new Error('variant');
          const colorIndex = this.data.options.findIndex(name => /colou?r/i.test(name));
          const colorChanged = colorIndex >= 0 && variant.options[colorIndex] !== this.selected.options[colorIndex];
          const position = {left: window.scrollX, top: window.scrollY};
          const fields = this.querySelector('[data-gr-option-fields]');
          const height = Math.ceil(fields.getBoundingClientRect().height);
          this.minimumHeight = Math.max(this.minimumHeight || 0, height);
          this.style.setProperty('--gr-options-height', `${this.minimumHeight}px`);
          const updateMedia = this.productInfo.updateMedia;
          this.selected = variant;
          this.productInfo.updateMedia = () => {};
          try {
            this.productInfo.handleUpdateProductInfo(this.data.url)(html);
          } finally {
            this.productInfo.updateMedia = updateMedia;
          }
          if (this.productInfo.dataset.updateUrl !== 'false') history.replaceState(history.state, '', url.pathname + url.search + location.hash);
          if (colorChanged) this.showColorMedia(variant, html, native);
          this.renderOptions();
          this.syncVisibility();
          const focus = this.querySelector(`a[data-gr-option-index="${optionIndex}"][aria-current="true"]`);
          focus?.focus({preventScroll: true});
          if (window.scrollX !== position.left || window.scrollY !== position.top) window.scrollTo({...position, behavior: 'instant'});
        } catch (error) {
          if (controller.signal.aborted) return;
          const status = this.querySelector('.gr-product-options__availability') || document.createElement('p');
          status.className = 'gr-product-options__availability';
          status.setAttribute('role', 'status');
          status.textContent = this.data.error;
          if (!status.parentNode) this.append(status);
        } finally {
          if (this.controller === controller) this.removeAttribute('aria-busy');
        }
      }
      showColorMedia(variant, html, native) {
        const photo = variant.image || this.data.variants.find(item => item.options.some((value, index) => /colou?r/i.test(this.data.options[index]) && value === variant.options[index]) && item.image)?.image;
        if (photo) {
          const file = new URL(photo, location.origin).pathname;
          const thumbnail = [...this.productInfo.querySelectorAll('.rio-media-gallery [role="button"] img')].find(image => new URL(image.src, location.origin).pathname === file);
          if (thumbnail) { thumbnail.closest('[role="button"]').click(); return; }
        }
        const gallery = this.productInfo.querySelector('media-gallery');
        gallery?.setActiveMedia?.(`${this.productInfo.dataset.section}-${native.featured_media?.id}`, false);
      }
      targetFor(index, value, isColor) {
        const candidates = this.data.variants.filter(variant => variant.options[index] === value);
        const exact = candidates.find(variant => variant.options.every((option, position) => position === index || option === this.selected.options[position]));
        if (!isColor) return exact || null;
        return (exact?.stock && exact) || candidates.find(variant => variant.stock) || exact || candidates[0] || null;
      }
      choicesFor(index, isColor) {
        if (isColor) return [...new Set(this.data.variants.map(variant => variant.options[index]))];
        const candidates = this.data.variants.filter(variant => variant.options.every((value, position) => position === index || value === this.selected.options[position]));
        const stocked = candidates.filter(variant => variant.stock);
        const visible = stocked.length ? stocked : candidates;
        return [...new Set(visible.map(variant => variant.options[index]).concat(this.selected.options[index]))];
      }
      renderOptions() {
        this.querySelector('[data-gr-option-fields]')?.remove();
        const content = document.createElement('div');
        content.setAttribute('data-gr-option-fields', '');
        this.data.options.forEach((name, index) => {
          const isColor = /colou?r/i.test(name);
          const field = document.createElement('fieldset');
          const legend = document.createElement('legend');
          legend.textContent = isColor ? `${name}: ${this.selected.options[index]}` : name;
          field.append(legend);
          const values = document.createElement('div');
          values.className = 'gr-product-options__values';
          const choices = this.choicesFor(index, isColor);
          if (!isColor) {
            const sizes = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL', '5XL', '6XL'];
            const natural = new Intl.Collator('es', { numeric: true, sensitivity: 'base' });
            choices.sort((a, b) => {
              const ai = sizes.indexOf(a.toUpperCase()), bi = sizes.indexOf(b.toUpperCase());
              return ai >= 0 && bi >= 0 ? ai - bi : natural.compare(a, b);
            });
          }
          choices.forEach(value => {
            const target = this.targetFor(index, value, isColor);
            const selected = this.selected.options[index] === value;
            if (!target) return;
            const control = document.createElement(target ? 'a' : 'span');
            control.className = 'gr-product-options__value';
            control.setAttribute('data-gr-variant', String(target.id));
            control.setAttribute('data-gr-option-index', String(index));
            control.setAttribute('aria-label', `${name}: ${value}`);
            control.title = value;
            const stocked = isColor
              ? this.data.variants.some(variant => variant.options[index] === value && variant.stock)
              : target.stock;
            if (!stocked) {
              control.setAttribute('data-sold-out', '');
              control.title = `${value} - ${this.data.soldOut}`;
              control.setAttribute('aria-label', `${name}: ${value} - ${this.data.soldOut}`);
            }
            if (target) {
              const url = new URL(this.data.url, location.origin);
              const preview = new URLSearchParams(location.search).get('preview_theme_id');
              if (preview) url.searchParams.set('preview_theme_id', preview);
              url.searchParams.set('variant', target.id);
              control.href = url.pathname + url.search;
            } else control.setAttribute('aria-disabled', 'true');
            if (selected) control.setAttribute('aria-current', 'true');
            const imageSource = isColor && (target?.image || this.data.variants.find(variant => variant.options[index] === value && variant.image)?.image);
            if (imageSource) {
              control.classList.add('gr-product-options__value--image');
              const image = document.createElement('img');
              image.src = imageSource;
              image.alt = value;
              image.width = 44;
              image.height = 44;
              control.append(image);
            } else control.textContent = value;
            values.append(control);
          });
          field.append(values);
          content.append(field);
        });
        if (!this.selected.stock) {
          const status = document.createElement('p');
          status.className = 'gr-product-options__availability';
          status.setAttribute('role', 'status');
          status.textContent = this.data.soldOut;
          content.append(status);
        }
        this.append(content);
      }
    }
    customElements.define('gr-product-options', GrProductOptions);
  }
  } catch(e) { console.error(e); }
})();

})();
